import React, { Component } from "react";
import {
  Box,
  Grid,
  Button,
  Backdrop,
  Container,
  Typography,
  CircularProgress,
  Card,
  CardContent,
  TextField,
} from "@mui/material";
import * as Yup from "yup";
import { Formik } from "formik";
import agent from "../../agent/agent";
import { showError, showSuccess } from "../../utils/notifications";

const validationSchema = Yup.object().shape({
  password: Yup.string()
    .min(8, 'Пароль должен содержать минимум 8 символов')
    .matches(/[a-z]/, 'Пароль должен содержать минимум одну прописную латинскую букву')
    .matches(/[A-Z]/, 'Пароль должен содержать минимум одну заглавную латинскую букву')
    .matches(/[0-9]/, 'Пароль должен содержать минимум одну цифру')
    .matches(/[!"#$%&'()*+,\-./:;<=>?@[\\\]^_`{|}~]/, 'Пароль должен содержать минимум один специальный символ')
    .required('Обязательно к заполнению'),
  password_confirmation: Yup.string()
    .oneOf([Yup.ref('password')], 'Пароли не совпадают')
    .required('Обязательно к заполнению'),
});

class Reset extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isBackdrop: false
    };
  }

  componentDidMount = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const token = urlParams.get('token');

    if (!token) {
      showError('Ошибка', 'Токен не найден в параметрах URL');
    }
  }

  onPasswordReset = async (values) => {
    await this.setState({ isBackdrop: true });
    const urlParams = new URLSearchParams(window.location.search);
    const token = urlParams.get('token') || '';
    const password = urlParams.get('password') || values.password;
    const password_confirmation = urlParams.get('password_confirmation') || values.password_confirmation;

    const body = {
      password: password,
      password_confirmation: password_confirmation,
      token: token,
      is_change_password: true
    };

    const resPasswordReset = await agent.post('/auth/registration', body)
      .then((res) => res.data).catch((err) => {
        return { error: err.response?.data?.details || 'Ошибка сервера, повторите попытку позднее.' }
      });
    if (resPasswordReset?.error) {
      await this.setState({ isBackdrop: false });
      showError('Ошибка сброса пароля', resPasswordReset?.error);
      return
    }

    showSuccess('Пароль успешно изменен');
    window.location.href = '/';
  }

  render() {
    const {
      isBackdrop
    } = this.state;

    const urlParams = new URLSearchParams(window.location.search);
    const passwordFromUrl = urlParams.get('password') || '';
    const passwordConfirmationFromUrl = urlParams.get('password_confirmation') || '';

    const initValues = {
      password: passwordFromUrl,
      password_confirmation: passwordConfirmationFromUrl
    };

    return (
      <Container maxWidth="sm">
        <Box py={4}>
          <Typography variant="h1" mb={1}>Подтверждение сброса пароля</Typography>
          <Card>
            <CardContent>
              <Formik
                initialValues={initValues}
                validationSchema={validationSchema}
                onSubmit={this.onPasswordReset}
              >{(props) => {
                const {
                  values,
                  errors,
                  touched,
                  handleSubmit,
                  handleChange
                } = props;
                return (
                  <Grid container spacing={2}>
                    <Grid size={12}>
                      <TextField
                        value={values.password}
                        type="password"
                        label="Пароль"
                        size="small"
                        name="password"
                        variant="outlined"
                        fullWidth
                        helperText={touched.password && errors.password}
                        error={Boolean(touched.password && errors.password)}
                        onChange={handleChange}
                      />
                    </Grid>
                    <Grid size={12}>
                      <TextField
                        value={values.password_confirmation}
                        type="password"
                        label="Подтверждение пароля"
                        size="small"
                        name="password_confirmation"
                        variant="outlined"
                        fullWidth
                        helperText={touched.password_confirmation && errors.password_confirmation}
                        error={Boolean(touched.password_confirmation && errors.password_confirmation)}
                        onChange={handleChange}
                      />
                    </Grid>
                    <Grid size={12}>
                      <Button
                        fullWidth
                        variant="contained"
                        onClick={handleSubmit}
                      >Подтвердить сброс пароля</Button>
                    </Grid>
                  </Grid>
                )
              }}</Formik>
            </CardContent>
          </Card>
        </Box>

        <Backdrop open={isBackdrop}>
          <CircularProgress />
        </Backdrop>
      </Container>
    );
  }
}

export default Reset
